import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ApplicantDetailsPreviewROWResponse } from "../application-preview/types";

export const ApplicantOrganisationDetailsROW: React.FC<{
  isExpanded: boolean;
  visible?: boolean;
  toggleExpand: () => void;
  data?: ApplicantDetailsPreviewROWResponse;
}> = ({ isExpanded, toggleExpand, data }) => {
  if (!data) return null;
  const { orgnizations, organizations } = data || [];
  const organizationDetails = orgnizations ?? organizations;

  const orgDetails = [
    {
      label: "Business Name",
      value: organizationDetails?.[0]?.business_name || "-",
    },
    {
      label: "Entity Type",
      value: organizationDetails?.[0]?.entity_type || "-",
    },
    {
      label: "Nature of Business",
      value: organizationDetails?.[0]?.business_nature || "-",
    },
    {
      label: "Registration Date",
      value: organizationDetails?.[0]?.registration_date || "-",
    },
    { label: "Address", value: organizationDetails?.[0]?.org_address || "-" },
    { label: "Pin Code", value: organizationDetails?.[0]?.pincode || "-" },
    { label: "CIN No", value: organizationDetails?.[0]?.cin || "-" },
    { label: "TIN No", value: organizationDetails?.[0]?.tin || "-" },
    { label: "GST No", value: organizationDetails?.[0]?.gst_number || "-" },
  ];

  const orgdetailsLayout = [
    [orgDetails[0], orgDetails[1]],
    [orgDetails[2], orgDetails[3]],
    [orgDetails[4], orgDetails[5]],
    [orgDetails[6], orgDetails[7]],
  ];

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Card sx={{ boxShadow: "none", border: "1px solid #E7E8E9" }}>
        {/* Header */}
        <Box
          sx={{
            backgroundColor: "#F4F2F7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E7E8E9",
            pl: 2,
            py: "5px",
          }}
        >
          <Typography
            sx={{ fontSize: 12 }}
            fontWeight="semi-bold"
            className="preview-dropdown-header"
          >
            Applicant Organisation Details
          </Typography>
          <IconButton aria-label="Collapse section" onClick={toggleExpand}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>

        {/* Content */}
        {isExpanded && ( // Conditionally render the content
          <CardContent>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} spacing={1}>
                <Box
                  sx={{
                    display: { xs: "block", sm: "flex" },
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {orgdetailsLayout.map((row, rowIndex) => (
                    <Box
                      key={`row-${rowIndex}`}
                      sx={{
                        display: { xs: "block", sm: "flex" },
                        justifyContent: "space-between",
                        gap: 4,
                      }}
                    >
                      {row.map((detail, colIndex) => (
                        <Box
                          key={`detail-${rowIndex}-${colIndex}`}
                          sx={{ flex: 1 }}
                        >
                          <Typography
                            className="preview-dropdown-label"
                            sx={{
                              fontWeight: "500",
                              mb: 0.5,
                              color: "#878787",
                            }}
                          >
                            {detail.label}
                          </Typography>
                          <Typography
                            sx={{ fontSize: "1rem" }}
                            className="preview-dropdown-value"
                          >
                            {detail.value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        )}
      </Card>
    </Box>
  );
};
